var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ScaleBox',{attrs:{"width":1920,"height":963,"bgc":"transparent","delay":100}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }